// Created on 2023-08-03
// Created by Vitaut Tryputsin
//
// Copyright (c) 2023 OPEN CASCADE SAS
//
// This file is part of commercial software by OPEN CASCADE SAS,
// furnished in accordance with the terms and conditions of the contract
// and with the inclusion of this copyright notice.
// This file or any part thereof may not be provided or otherwise
// made available to any third party.
//
// No ownership title to the software is transferred hereby.
//
// OPEN CASCADE SAS makes no representation or warranties with respect to the
// performance of this software, and specifically disclaims any responsibility
// for any damages, special or consequential, connected with its use.
/**
 * This enumeration defines a list of predefined camera view directions.
 * It represents a subset of values of corresponding C++ `V3d_TypeOfOrientation` enumeration defined by OCCT.
 */
export var V3d_TypeOfOrientation;
(function (V3d_TypeOfOrientation) {
    V3d_TypeOfOrientation[V3d_TypeOfOrientation["LEFT"] = 3] = "LEFT";
    V3d_TypeOfOrientation[V3d_TypeOfOrientation["RIGHT"] = 0] = "RIGHT";
    V3d_TypeOfOrientation[V3d_TypeOfOrientation["BOTTOM"] = 5] = "BOTTOM";
    V3d_TypeOfOrientation[V3d_TypeOfOrientation["TOP"] = 2] = "TOP";
    V3d_TypeOfOrientation[V3d_TypeOfOrientation["FRONT"] = 4] = "FRONT";
    V3d_TypeOfOrientation[V3d_TypeOfOrientation["BACK"] = 1] = "BACK";
    V3d_TypeOfOrientation[V3d_TypeOfOrientation["AXORIGHT"] = 19] = "AXORIGHT";
    V3d_TypeOfOrientation[V3d_TypeOfOrientation["AXOLEFT"] = 24] = "AXOLEFT";
    V3d_TypeOfOrientation[V3d_TypeOfOrientation["XnegYneg"] = 9] = "XnegYneg";
    V3d_TypeOfOrientation[V3d_TypeOfOrientation["XposYneg"] = 15] = "XposYneg";
    V3d_TypeOfOrientation[V3d_TypeOfOrientation["Axial"] = 5] = "Axial";
    V3d_TypeOfOrientation[V3d_TypeOfOrientation["Frontal"] = 4] = "Frontal";
    V3d_TypeOfOrientation[V3d_TypeOfOrientation["Sagittal"] = 0] = "Sagittal";
    V3d_TypeOfOrientation[V3d_TypeOfOrientation["FrontalLeft"] = 15] = "FrontalLeft";
    V3d_TypeOfOrientation[V3d_TypeOfOrientation["FrontalRight"] = 9] = "FrontalRight";
})(V3d_TypeOfOrientation || (V3d_TypeOfOrientation = {}));
/**
 * This enumeration defines a list of camera rotation modes.
 * It reflects values of corresponding C++ `AIS_RotationMode` enumeration defined by OCCT.
 *
 * For using this enum please use its implementation from [[OccViewer.AIS_RotationMode]].
 */
export var AIS_RotationMode;
(function (AIS_RotationMode) {
    /** Rotate around bounding box of active object, `AIS_RotationMode_BndBoxActive`. */
    AIS_RotationMode[AIS_RotationMode["BndBoxActive"] = 0] = "BndBoxActive";
    /** Rotate around last picked point, `AIS_RotationMode_PickLast`. */
    AIS_RotationMode[AIS_RotationMode["PickLast"] = 1] = "PickLast";
    /** Rotate around point at the center of window, `AIS_RotationMode_PickCenter`. */
    AIS_RotationMode[AIS_RotationMode["PickCenter"] = 2] = "PickCenter";
    /** Rotate around camera center, `AIS_RotationMode_CameraAt` */
    AIS_RotationMode[AIS_RotationMode["CameraAt"] = 3] = "CameraAt";
    /** Rotate around scene center, `AIS_RotationMode_BndBoxScene`. */
    AIS_RotationMode[AIS_RotationMode["BndBoxScene"] = 4] = "BndBoxScene";
})(AIS_RotationMode || (AIS_RotationMode = {}));
/**
 * (Sub)view corner defined by `ViewCorner` enumeration.
 */
export var ViewCorner;
(function (ViewCorner) {
    ViewCorner[ViewCorner["Free3d"] = -1] = "Free3d";
    ViewCorner[ViewCorner["CenterCenter"] = 0] = "CenterCenter";
    ViewCorner[ViewCorner["CenterUpper"] = 1] = "CenterUpper";
    ViewCorner[ViewCorner["CenterLower"] = 2] = "CenterLower";
    ViewCorner[ViewCorner["LeftCenter"] = 4] = "LeftCenter";
    ViewCorner[ViewCorner["LeftUpper"] = 5] = "LeftUpper";
    ViewCorner[ViewCorner["LeftLower"] = 6] = "LeftLower";
    ViewCorner[ViewCorner["RightCenter"] = 8] = "RightCenter";
    ViewCorner[ViewCorner["RightUpper"] = 9] = "RightUpper";
    ViewCorner[ViewCorner["RightLower"] = 10] = "RightLower";
})(ViewCorner || (ViewCorner = {}));
